// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oMVj","col":"styles_col__2vt-c"};